// extracted by mini-css-extract-plugin
export default {"root":"UserRatingStrip_root__SWE6E","rank":"UserRatingStrip_rank__qt-Vb","details":"UserRatingStrip_details__I+q9q"};